import { CardTitle, CardHeader } from "@/components/ui/card";

export default function FormTitle({ children }) {
    return <CardTitle className="text-xl font-medium">{children}</CardTitle>;
}
